import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_SALE_HISTORY} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'
import {push} from '@web/slices/router'

import {LocationChangeHistoryWithRouteParam, ThunkApi} from '../interfaces'

type NavigateToSaleHistoryParam = LocationChangeHistoryWithRouteParam & {
    orderNo: string
}

/** 판매내역 */
const navigateToSaleHistoryDetail = createAsyncThunk<void, NavigateToSaleHistoryParam, ThunkApi<unknown>>(
    'navigateTo/sale/history/detail',
    ({historyType = 'PUSH', orderNo, routeBased = false}, {dispatch}) => {
        if (routeBased) {
            dispatch(push(ROUTER_ORDER_SALE_HISTORY.MAIN.getPath(`${orderNo}`), {resetScroll: routeBased}))
        } else {
            changeBrowserLocation({
                type: historyType,
                url: ROUTER_ORDER_SALE_HISTORY.MAIN.getHref(`${orderNo}`),
            })
        }
    },
)

export default navigateToSaleHistoryDetail
